import React from 'react';
import { MaterialSymbol } from 'react-material-symbols';
import { useMaterialSymbols } from './MaterialSymbolsProvider';
import './MaterialIcon.scss';

/**
 * MaterialIcon - Wrapper component untuk MaterialSymbol yang menyembunyikan
 * nama icon sampai Material Symbols font siap dimuat
 */
const MaterialIcon = ({ icon, size = 24, className = '', ...props }) => {
  const { isReady } = useMaterialSymbols();

  return (
    <span 
      className={`material-icon-wrapper ${className}`}
      data-icon={icon}
      data-ready={isReady}
    >
      {isReady ? (
        <MaterialSymbol 
          icon={icon} 
          size={size} 
          className={className}
          {...props}
        />
      ) : (
        <span 
          className="material-icon-placeholder" 
          aria-hidden="true"
          style={{ width: `${size}px`, height: `${size}px` }}
        >
          {/* Empty placeholder to prevent icon name from showing */}
        </span>
      )}
    </span>
  );
};

export default MaterialIcon;
